import { render, staticRenderFns } from "./deanTable.vue?vue&type=template&id=0537e4d4&scoped=true"
import script from "./deanTable.vue?vue&type=script&lang=ts"
export * from "./deanTable.vue?vue&type=script&lang=ts"
import style0 from "./deanTable.vue?vue&type=style&index=0&id=0537e4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0537e4d4",
  null
  
)

export default component.exports